import { render, staticRenderFns } from "./Sync.vue?vue&type=template&id=5881e91c&scoped=true"
import script from "./Sync.vue?vue&type=script&lang=js"
export * from "./Sync.vue?vue&type=script&lang=js"
import style0 from "./Sync.vue?vue&type=style&index=0&id=5881e91c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5881e91c",
  null
  
)

export default component.exports